<template>
  <v-container grid-list-md text-md-center>
    <v-layout row wrap>
      <v-flex xl8 offset-xl2 xs12>

        <h1>{{ event.eventName }}</h1>

        <p class="info-text ql-editor" v-html="eventInfo.introductionText">
        </p>

        <div class="ma-12">
          <v-btn
            color="primary" x-large
            rounded
            tag="a"
            href="https://faq.kentei-uketsuke.com/faq/ipe/list?site=YUMKE0K1&category=1124"
            target="_blank"
          >よくあるご質問
          </v-btn>
        </div>

        <div class="subTitle">
          <span>電子申請用メールアドレス登録</span>
        </div>
        <p class="info-text ql-editor" v-html="eventInfo.emailRegistrationNotice">
          初回のみ電子申請システムへのメールアドレス登録が必要となります。<br>
          必ず下記の個人情報の取り扱いについて同意の上、ご登録ください。<br>
          【個人情報保護方針について】
          <a href="https://www.jnto.go.jp/jpn/site_info/privacy_policy.html" target="_blank">https://www.jnto.go.jp/jpn/site_info/privacy_policy.html</a><br>
          日本政府観光局(JNTO)は、2021年度の全国通訳案内士試験に係る事務手続き、試験運営業務等を株式会社TKPコミュニケーションズに委託しています。<br>
          全国通訳案内士試験出願及び試験により取得した個人情報は、全国通訳案内士試験実施事務及び統計目的以外には一切使用することはありません。<br>
          <br>
          【メールアドレス登録方法】<br>
          下記「メールアドレス入力」フォームにメールアドレスをご入力いただき、「個人情報の取り扱いに同意の上、電子申請用メールアドレスを登録する」ボタンを押してください。<br>
          メールアドレスの登録が完了すると自動返信メールにて「メールアドレス入力完了確認のご連絡」が送付されます。<br>
          メール受信後３０分以内に初期パスワード設定が必要となりますので、メールをご確認の上、初期設定を行ってください。<br>
          ※メール受信後30分以内に初期パスワードの設定ができなかった場合は、再度、電子申請用メールアドレスの登録を行ってください。<br>
          ※申請者ご自身のメールアドレスをご登録ください。<br>
          ※電子申請システムのマイページのログイン時にご登録のメールアドレスが必要となります。<br>
          ※ご登録いただいたメールアドレス宛に事務局からご連絡することがございますので、guide-jimukyoku@tkpcom.jpからのメールを受信できるようにしてください。<br>
          ※1つのメールアドレスを重複してご利用（登録）いただくことはできません。<br>
          ※代理人の方が同じメールアドレスを用いて複数人の代理申請をすることはできません。
        </p>

        <template v-if="entryOpened || isPre">
          <v-form ref="form">
            <v-text-field
              v-model="email"
              type="email"
              label="メールアドレス入力"
              outlined
              :rules="[rules.required, rules.email]"
            ></v-text-field>
            <v-btn
              color="primary"
              @click.stop="sendInvitation"
              class="pa-7"
            >上記の個人情報の取り扱いに同意の上<br>
              電子申請用メールアドレスを登録する
            </v-btn>
          </v-form>
          <div class="ma-12" v-if="!isAfterMypageClosedAt">
            <v-btn
              color="primary" x-large
              class="font-weight-bold px-16"
              @click.stop="$emit('openLogin')"
            >マイページログイン
            </v-btn>
          </div>
        </template>
        <template v-else>
          <p></p>
        </template>

        <div class="subTitle">
          <span>お知らせ</span>
        </div>
        <p class="info-text ql-editor" v-html="eventInfo.notificationsText">
          こちらには願書申請システムに関するお知らせと、試験前日～当日の緊急連絡に関する
          お知らせを掲載します。
        </p>

        <div class="subTitle">
          <span>願書申請の注意事項</span>
        </div>
        <p class="info-text ql-editor" v-html="eventInfo.entryNotice">
          こちらには願書申請システムに関するお知らせと、試験前日～当日の緊急連絡に関する
          お知らせを掲載します。
        </p>

        <!--        <div class="subTitle">-->
        <!--          <span>よくあるご質問</span>-->
        <!--        </div>-->
        <!--        <v-card-->
        <!--          class="mb-12"-->
        <!--          color="grey lighten-1"-->
        <!--          height="200px"-->
        <!--        ></v-card>-->
        <div class="ma-12">
          <v-btn
            color="primary" x-large
            rounded
            tag="a"
            href="https://faq.kentei-uketsuke.com/faq/ipe/list?site=YUMKE0K1&category=1124"
            target="_blank"
          >よくあるご質問
          </v-btn>
        </div>


        <div class="subTitle">
          <span>お問い合わせ先</span>
        </div>
        <p class="text-left my-5 ml-5">
          ＜全国通訳案内士試験事務局＞<br>
          TEL. 04-7131-6200<br>
          （土・日・祝・年末年始除く10：00～17：00）<br>
          ▶お問い合わせは、<a href="https://mdr0028.maildealer.jp/f.php?c=8&s=71bb" target="_blank">こちら</a>からお願いいたします。
        </p>
        <p class="text-left text-caption">
          日本政府観光局(JNTO)は、2025年度の全国通訳案内士試験に係る事務手続き、<br>
          試験運営業務等を日販セグモ株式会社に委託しています。
        </p>

      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import Rules from '../mixins/RulesMixin'
import {mapGetters} from 'vuex'
//No.10 結果通知画面: table module追加
import "quill-table/src/css/quill.table.css";
function chatbotInit () {
  let script = document.createElement('script')
  script.setAttribute('src', 'https://ws.cv-agaru.com/client/60d910896f1ef.js')
  document.body.appendChild(script)
}

export default {
  mixins: [Rules],
  data () {
    return {
      email: '',
    }
  },
  computed: {
    ...mapGetters([
      'event', 'eventInfo', 'entryOpened', 'isPre', 'isAfterMypageClosedAt'
    ])
  },
  mounted () {
    if (process.env.VUE_APP_NODE_ENV == 'production') {
      // chatbotInit()
    }
  },
  methods: {
    async sendInvitation () {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        let response = await axios.post('/api/account/register', {
          email: this.email
        })
        this.$emit('toast', 'メールを送信しました')
      } catch (e) {
        console.error('failed', e)
        if (e.response.status === 409) {
          return this.$emit('error', 'そのメールアドレスは既に登録されています')
        }
      }
    }
  }
}
</script>
